import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/pro-regular-svg-icons";

export default function Loading() {
  return (
    <div className="Loading">
      <FontAwesomeIcon icon={faSpinner} spin />
    </div>
  );
}
